<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "MSProposalInsureds",
	components: { CaseForm },
	computed: {
		schema() {
			return [
				{
					label: "Select Insured",
					component: "entitySelect",
					bindTo: "case.insureds[0]",
					entity: "case.insureds[0]",
					props: {
						allowedEntityTypes: ["object"]
					}
				},
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0AddressId",
					props: {
						suggest: {
							typeIncludes: "main"
						},
						createOptions: {
							type: "main"
						}
					}
				},
				{
					label: "Business / Occupation",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.natureOfBusiness",
					props: {
						suggest: {
							typeIncludes: "natureOfBusiness"
						},
						createOptions: {
							type: "natureOfBusiness",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
